import React from 'react';
import {
  CapabilityCard,
  CapabilityCardPortalPreview
} from '@thd-olt-component-react/capability_card';
import { chunkArray } from '../../utils';
import '../callout_card.scss';

const mdSlides = (slides, isPortalLivePreview = false, enableB2CRadius = false) => slides?.map((group, groupKey) => {
  const rowsPerSlide = chunkArray(group, 2);

  return (
    <div className="sui-flex sui-w-full sui-gap-y-6 sui-flex-col" key={groupKey}>
      {rowsPerSlide?.map((row, rowKey) => {
        return (
          <div className="sui-grid sui-grid-cols-2 sui-grid-rows-1 sui-gap-x-6" key={rowKey}>
            {row?.map((card, cardKey) => {
              const cardId = card.id || card.sys?.id || `capability-card-${cardKey}`;

              return (
                <div className="row_card" key={cardKey + cardId}>
                  {isPortalLivePreview
                    ? (
                      <CapabilityCardPortalPreview
                        componentId={cardId}
                        componentClass="CapabilityCard"
                        portalPreviewData={card}
                        isHorizontal
                      />
                    ) : (
                      <CapabilityCard
                        headline={card.headline}
                        richText={typeof card.richTextContent === 'string'
                          ? card.richTextContent
                          : JSON.stringify(card.richTextContent?.json)}
                        componentPosition={cardKey + 1}
                        componentId={cardId}
                        enableB2CRadius={enableB2CRadius}
                      />
                    )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
});

export default mdSlides;
